var map = {
	"./3Crv-logo.png": 577,
	"./BAT-logo.png": 578,
	"./BUSD-logo.png": 579,
	"./COMP-logo.png": 580,
	"./CRV-logo.png": 581,
	"./DAI-logo.png": 582,
	"./ETH-logo.png": 583,
	"./FTM-logo.png": 584,
	"./GUSD-logo.png": 585,
	"./KNC-logo.png": 586,
	"./LEND-logo.png": 587,
	"./LINK-logo.png": 588,
	"./MANA-logo.png": 589,
	"./MKR-logo.png": 590,
	"./REP-logo.png": 591,
	"./SAI-logo.png": 592,
	"./SNX-logo.png": 593,
	"./SUSD-logo.png": 594,
	"./TUSD-logo.png": 364,
	"./USD-logo.png": 595,
	"./USDC-logo.png": 596,
	"./USDT-logo.png": 597,
	"./WETH-logo.png": 598,
	"./YFI-logo.png": 256,
	"./ZRX-logo.png": 599,
	"./aLINK-logo.png": 600,
	"./cDAIcUSDC-logo.png": 601,
	"./cUSDC-logo.png": 602,
	"./cUSDT-logo.png": 603,
	"./crvBTC-logo.png": 604,
	"./crvBUSD-logo.png": 605,
	"./iDAI-logo.png": 606,
	"./wBTC-logo.png": 607,
	"./yCRV-logo.png": 608,
	"./ycUSDC-logo.png": 609,
	"./ycUSDT-logo.png": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;